export const AT_NOTIFICATION = {
    READ_ALL_NOTIFICATIONS    : "READ_ALL_NOTIFICATIONS",
    TOGGLE_NOTIFICATION_PANEL    : "TOGGLE_NOTIFICATION_PANEL",
};

export const AT_COMMENT = {
    SET_COMMENTS    : "SET_COMMENTS",
};